<script>
  /* eslint-disable */
  import { createEventDispatcher } from 'svelte'

  export let hasIcon = false
  export let disabled = false
  export let icon
  export let backgroundColor = '#0a0f3b'
  export let textColor = '#f9f9f9'
  export let btnTheme = 'large'
  export let buttonText
  export let textTransform
  export let customStyle = ''

  $: iconStyle = `url(${icon})`

  const dispatch = createEventDispatcher()

  function handleClick() {
    dispatch('buttonClicked', {
      name: name
    })
  }
</script>

<style>
  .kb-button {
    border: 0;
    font-size: 14px;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    box-shadow: none;
    outline: none;
  }

  .kb-button--large {
    min-width: 170px;
    padding: 12px 20px;
    height: 38px;
  }

  .kb-button--small {
    min-width: 132px;
    padding: 6px 9px;
    height: 32px;
  }

  .kb-button-icon {
    content: var(--icon-url);
    margin-right: 5px;
  }

  .kb-button:active,
  .kb-button:focus {
    outline: none;
    border: 0;
    box-shadow: none;
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }
</style>

<button
  class={`kb-button kb-button--${btnTheme}`}
  style="--icon-url: {iconStyle}; background: {backgroundColor}; color: {textColor};{textTransform ? ` text-transform: ${textTransform};` : ''}
  {customStyle}"
  class:disabled
  on:click={handleClick}>
  <i class:kb-button-icon={hasIcon} />
  {buttonText}
</button>
